import { render } from "./AppBtn.vue?vue&type=template&id=8c863962&ts=true"
import script from "./AppBtn.vue?vue&type=script&lang=ts"
export * from "./AppBtn.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__